import { render } from "./DatabaseView.vue?vue&type=template&id=bed4a87c&scoped=true"
import script from "./DatabaseView.vue?vue&type=script&lang=js"
export * from "./DatabaseView.vue?vue&type=script&lang=js"

import "./DatabaseView.vue?vue&type=style&index=0&id=bed4a87c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed4a87c"]])

export default __exports__